import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

import { API } from '@/config/api';

// Reads the Notion-synced mirror (notion_tasks). Read-only mirror of Notion's own
// Tasks database -- any detail view just displays these, never edits them here.
export const useOperationsTasks = (projectNotionPageId) => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTasks = useCallback(async () => {
    try {
      setLoading(true);
      const params = projectNotionPageId ? { project_notion_page_id: projectNotionPageId } : {};
      const response = await axios.get(`${API}/operations/tasks`, { params });
      setTasks(Array.isArray(response.data) ? response.data : []);
      setError(null);
    } catch (err) {
      console.error('Error fetching operations tasks:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [projectNotionPageId]);

  useEffect(() => {
    fetchTasks();
  }, [fetchTasks]);

  return { tasks, loading, error, refetch: fetchTasks };
};
